export default __webpack_public_path__ + "static/media/facebook.bfd1cfff.png";